export async function sleep(time: number) {
  await new Promise((resolve) => setTimeout(resolve, time));
}

export enum SleepResolutionType {
  CANCELLED = 'cancelled',
  COMPLETE = 'complete',
}

export type Timeout = {
  promise: Promise<SleepResolutionType>;
  cancel: () => void;
};

export const cancellableSleep = (time: number): Timeout => {
  let resolveTimeout: (resolutionType: SleepResolutionType) => void = undefined as any;
  const promise = new Promise<SleepResolutionType>(
    (resolve) => (resolveTimeout = resolve),
  );

  setTimeout(() => resolveTimeout(SleepResolutionType.COMPLETE), time);

  const cancel = () => {
    resolveTimeout(SleepResolutionType.CANCELLED);
  };

  return {
    promise,
    cancel,
  };
};
